import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/actor.css";

const Actor = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const [selectedJob, setSelectedJob] = useState(null);

	const handleJobClick = (job) => {
		setSelectedJob(job);
	};

	const handleClosePopup = () => {
		setSelectedJob(null);
	};

	const currentSEO = SEO.find((item) => item.page === "actor");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Actor | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="actor" />
				<div className="content-wrapper">
					<div className="actor-logo-container">
						<div className="actor-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="actor-main-container">
						<div className="title actor-title">
							{INFO.actor.title}
						</div>

						<div className="subtitle actor-subtitle">
							{INFO.actor.description}
						</div>

						<div className="actor-container">
							<div className="actor-wrapper">
								{INFO.actor.jobs.map((job, index) => (
									<div className="actor-job-card" key={index} onClick={() => handleJobClick(job)}>
										<div className="actor-job-image">
											<img src={job.image} alt={job.title} />
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
					{selectedJob && (
						<div className="actor-popup-overlay" onClick={handleClosePopup}>
							<div className="actor-popup" onClick={(e) => e.stopPropagation()}>
								<button className="actor-popup-close" onClick={handleClosePopup}>
									&times;
								</button>
								<img src={selectedJob.image} alt={selectedJob.title} className="actor-popup-image" />
								<div className="actor-popup-title">{selectedJob.title}</div>
							</div>
						</div>
					)}
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Actor;
